module.exports = __webpack_public_path__ + "static/img/data1-list2.4cd9303e.png";